export const SET_PENDING_ORDERS = 'SET_PENDING_ORDERS';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_SELECTED_ORDER_ID = 'SET_SELECTED_ORDER_ID';
export const SET_SELECTED_ORDER = 'SET_SELECTED_ORDER';
export const SET_NUMBER_POOL = 'SET_NUMBER_POOL';
export const SET_NUMBER_POOLS = 'SET_NUMBER_POOLS';
export const SET_SELECTED_NUMBER_POOL = 'SET_SELECTED_NUMBER_POOL';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';
export const SET_ACTION_STATUS_PENDING = 'SET_ACTION_STATUS_PENDING';
export const SET_ACTION_STATUS_SUCCESS = 'SET_ACTION_STATUS_SUCCESS';
export const SET_ACTION_STATUS_ERROR = 'SET_ACTION_STATUS_ERROR';
export const SET_NUMBER_POOL_REFERENCES = 'SET_NUMBER_POOL_REFERENCES';
export const SET_CHECK_REFERENCES_TEXT = 'SET_CHECK_REFERENCES_TEXT';
export const SET_ACCOUNT_SETTINGS = 'setAccountSettings';
export const SET_WIDGET_TITLE = 'SET_WIDGET_TITLE';
export const SET_DAY_STATS = 'SET_DAY_STATS';
export const SET_MONTH_STATS = 'SET_MONTH_STATS';
export const SET_NUMBER_AVAILABLE_COUNTRIES = 'SET_NUMBER_AVAILABLE_COUNTRIES';
